<template>
  <material-card
    :title="$t('components.plancreationwizard.bulk_import_coverage_parameters.title')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="publish"
  >
    <v-card-text>
      <v-dialog v-model="dialog" persistent max-width="400">
        <v-card>
          <v-card-title class="headline">
            {{ $t("globals.cancel_wizard") }}
          </v-card-title>
          <v-card-text>
            {{
              $t(
                "components.inmemorystores.if_you_exit_the_wizard_any_changes_made_so_far"
              )
            }}
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="dialog = false">
              {{ $t("globals.keep_working") }}
            </v-btn>
            <v-btn color="primary" @click="cancel()">
              {{ $t("globals.cancel_anyway") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-subheader class="pa-0 pl-4">
        {{
          $t(
            "components.plancreationwizard.bulk_import_coverage_parameters.subheader"
          )
        }}
      </v-subheader>
      <!-- <v-stepper v-model="step" vertical class="elevation-0"> -->
      <!-- <v-stepper-step :complete="step > 1" :step="1">
          {{
            $t(
              "components.membersimportwizardcomponent.download_data_template_optional"
            )
          }}
          <small>
            {{
              $t(
                "components.membersimportwizardcomponent.download_and_use_a_data_template_in_xlsx_format_you"
              )
            }}
          </small>
        </v-stepper-step>
        <v-stepper-content :step="1">
          <v-container fluid class="pt-0">
            <small>
              {{
              $t(
                "components.plan_builder.coverage_parameters_import_wizard.template_note"
              )
              }}
            </small>
            <v-row fluid>
              <v-col col="auto">
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Client Name</th>
                        <th class="text-left">Client Number</th>
                        <th class="text-left">Class</th>
                        <th class="text-left">Name</th>
                        <th class="text-left">Parameter Type</th>
                        <th class="text-left">Participates in Formula</th>
                        <th class="text-left">Coverage</th>
                        <th class="text-left">Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Turning Point Incorporated</td>
                        <td>4</td>
                        <td>Class 1</td>
                        <td>Premium Volume Max - Life - 4</td>
                        <td>Amount</td>
                        <td>Premium Volume</td>
                        <td>Life - Turning Point Incorporated</td>
                        <td>150000</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
            <v-row fluid>
              <v-col class="col-auto">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      slot="activator"
                      color="success"
                      :loading="downloading"
                      :disabled="downloading"
                      v-on="on"
                    >
                      {{
                        $t("globals.download")
                      }}
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="downloadTemplate(false)">
                      <v-list-item-title>
                        {{
                          $t("components.membersimportwizardcomponent.empty")
                        }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="downloadTemplate(true)">
                      <v-list-item-title>
                        {{
                          $t(
                            "components.membersimportwizardcomponent.all_members"
                          )
                        }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
              <v-col class="col-auto">
                <v-btn color="primary" @click="step = 2">
                  {{ $t("globals.continue") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-stepper-content> -->
      <v-col class="font-weight-bold pa-0 pl-4">
        {{
            $t(
              "components.plancreationwizard.bulk_import_wizard_coverage_parameters.upload_parameters"
            )
        }}
      </v-col>
      <small class="pl-4">
        {{
              $t(
                "components.plan_builder.employers_import_wizard.choose_the_file_to_import_data_from_using_the_select"
              )
        }}
      </small>
      <br />
      <small class="pl-4">
        {{
              $t(
                "components.plan_builder.coverage_parameters_import_wizard.template_note"
              )
        }}
      </small>
      <v-row>
        <v-col col="auto" class="px-6">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Client Name</th>
                  <th class="text-left">Client Number</th>
                  <th class="text-left">Class</th>
                  <th class="text-left">Name</th>
                  <th class="text-left">Parameter Type</th>
                  <th class="text-left">Participates in Formula</th>
                  <th class="text-left">Coverage</th>
                  <th class="text-left">Value</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Turning Point Incorporated</td>
                  <td>4</td>
                  <td>Class 1</td>
                  <td>Premium Volume Max - Life - 4</td>
                  <td>Amount</td>
                  <td>Premium Volume</td>
                  <td>Life - Turning Point Incorporated</td>
                  <td>150000</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" class="pl-4">
          <div>
            <v-file-input
              show-size
              accept=".xlsx"
              ref="file"
              v-on:change="handleParametersChange"
            />
          </div>
        </v-col>
      </v-row>
      <span v-if="uploading">
        {{ $t("components.membersimportwizardcomponent.please_wait") }}
      </span>
      <div v-if="uploaded && validationErrors.length === 0" class="px-4">
        <v-banner icon="done" color="success" elevation="0" icon-color="white">
          {{ uploadResult }}
        </v-banner>
      </div>
      <div class="px-4">
        <template v-for="(error, i) in validationErrors">
          <v-alert dense type="error" :key="i">{{ error }}</v-alert>
        </template>
      </div>
      <!-- <v-card-actions>
            <v-btn :disabled="uploading" text @click="step = 1">
              {{ $t("globals.back") }}
            </v-btn>
            <v-col class="col-auto">
              <v-btn
                :disabled="!uploaded || validationErrors.length > 0"
                color="primary"
                @click="step = 2"
              >
                {{ $t("globals.continue") }}
              </v-btn>
            </v-col>
          </v-card-actions> -->
      <!-- </v-stepper> -->
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        :disabled="uploading"
        text
        color="blue darken-1"
        @click="dialog = true"
      >
        {{ $t("globals.cancel") }}
      </v-btn>
      <v-btn
        color="primary"
        @click="finish"
        :disabled="validationErrors.length > 0"
      >
        {{ $t("globals.finish") }}
      </v-btn>
    </v-card-actions>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import * as ExcelJS from "exceljs";

export default {
  components: {
    ErrorHandler,
  },
  props: {
    coverage: {
      type: Array,
      default: () => [],
    },
    formulaTypes: {
      type: Array,
      default: () => [],
    },
    contributionCategories: {
      type: Array,
      default: () => [],
    },
    employers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      error: null,
      step: 1,
      dialog: false,
      uploaded: false,
      uploading: false,
      uploadResult: "",
      downloading: false,
      parameters: [],
      validationErrors: [],
      parametersColumnsMatches: {
        "Client Name": "ClientName",
        "Client Number": "ClientNumber",
        Class: "Class",
        Name: "Name",
        "Parameter Type": "ParameterType",
        "Participates in Formula": "UsedInFormulaType",
        Coverage: "Coverage",
        Value: "Value",
      },
    };
  },
  computed: {
    ...mapGetters("common", {
      settings: "settings",
      selectedPlan: "plan",
      language: "language",
    }),
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    step: {
      handler(v) {
        switch (v) {
          case 1: {
            break;
          }
          default: {
            this.uploaded = false;
            this.uploadResult = "";
            this.uploading = false;
            break;
          }
        }
      },
    },
  },
  methods: {
    ...mapActions("plansMembers", ["getBlobAsync"]),
    handleParametersChange(file) {
      console.log(file);
      if (!file) {
        this.file = null;
        return;
      }
      if (file.length == 0) {
        return;
      }
      this.onUploadStarted();
      var reader = new FileReader();
      reader.onload = async (event) => {
        var data = event.target.result;
        console.log(data);
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(data);
        // var worksheet = workbook.getWorksheet("Data");
        var worksheet = workbook.worksheets[0]; //get the first worksheet tab in excel file;
        const headers = [];
        const headersMap = {};
        const parameters = [];
        worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
          console.log(row);
          console.log("Row " + rowNumber + " = " + JSON.stringify(row.values));
          if (rowNumber === 1) {
            let index = 1;
            for (const v of row.values) {
              const match = this.parametersColumnsMatches[v];
              if (match!== null && match !== undefined) {
              headers.push(match);
              headersMap[match] = index;
              index++;
              }
            }
            console.log("headers match", headers, headersMap);
          } else {
            const jsonRow = {
              Identifier: Math.random(),
              ConfigurationParameter: {
                Identity: {}
              },
              ConfigurationParameterValue: {},
            };
            // excel js always adds first column in row as null so for values we need to get i + 1
            for (let i = 0; i < row.values.length; i++) {
              if (headers[i] === "Name") {
                jsonRow.ConfigurationParameter.Translations = [
                  {
                    LanguageCode: "en",
                    Name: row.values[i + 1],
                  },
                  {
                    LanguageCode: "fr",
                    Name: row.values[i + 1],
                  },
                ];
              } else if (headers[i] === "ParameterType") {
                jsonRow.ConfigurationParameter.ParameterType = row.values[i + 1]
                if (row.values[i + 1] === "Amount" || row.values[i + 1] === "Percentage" || row.values[i + 1] === "Rate") {
                  jsonRow.ConfigurationParameter.Type = "System.Double";
                }
                if (row.values[i + 1] === "Constant") {
                  if (row.values[i + 4] % 1 !== 0) {
                    jsonRow.ConfigurationParameter.Type = "System.Double";
                  } else {
                    jsonRow.ConfigurationParameter.Type = "System.Int32";
                  }
                }
              } else if (headers[i] === "UsedInFormulaType") {
                // console.log("UsedInFormulaType", row.values[i + 1]);
                if ( row.values[i + 1] !== null && row.values[i + 1] !== undefined) {
                  jsonRow.ConfigurationParameter.UsedInFormulaType = row.values[i + 1].replaceAll(" ", "");
                  // Employer Contribution
                  if (row.values[i + 1] === "Employer Contribution") {
                    let category = this.contributionCategories.filter(
                      (o) =>
                        o.Category == row.values[headersMap["ClientNumber"]]
                    )[0];
                    jsonRow.ContributionCategory = category;
                    console.log("category", category);
                  }
                  // Pension Accrued Benefit
                  if (row.values[i + 1] === "Pension Accrued Benefit") {
                    let employer = this.employers.filter(
                      (o) =>
                        o.Name == row.values[headersMap["ClientName"]]
                    )[0];
                    jsonRow.ConfigurationParameter.Identity.Employer = employer;
                    console.log("employer", employer);
                  }
                } else {
                  jsonRow.ConfigurationParameter.UsedInFormulaType = row.values[i + 1];
                }
              } else if (headers[i] === "Coverage" && jsonRow.ConfigurationParameter.UsedInFormulaType === "AdminFee") {
                let coverage = this.coverage.filter(
                  (o) =>
                    o.Name === row.values[i + 1]
                )[0];
                if (coverage === null || coverage === undefined) {
                  this.validationErrors.push(
                    coverage = this.coverage.filter(
                      (o) =>
                      o.Description === row.values[i + 1]
                    )[0]
                  );
                }
                jsonRow.ConfigurationParameter.Coverage = coverage;
              } else if (headers[i] === "Value") {
                jsonRow.ConfigurationParameterValue.Value = row.values[i + 1]
              } else {
                jsonRow[headers[i]] = row.values[i + 1];
              }
              if (jsonRow[headers[i]] === "") {
                jsonRow[headers[i]] = null;
              }
            }
            parameters.push(jsonRow);
          }
        });
        // this.$forceUpdate();
        // console.log(JSON.stringify(this.parameters));
        this.validateParameters(parameters);
        this.onUploadCompleted();
      };
      reader.onerror = () => {
        this.onUploadError(reader.error);
      };
      reader.readAsBinaryString(file);
    },
    validateParameters(parameters) {
      this.validationErrors = [];
      for (let i = 0; i < parameters.length; i++) {
        if (parameters[i].ConfigurationParameter.Translations === null || parameters[i].ConfigurationParameter.Translations === undefined || parameters[i].ConfigurationParameter.Translations.length === 0 || parameters[i].ConfigurationParameter.Translations.filter(o => o.Name !== null && o.Name !== undefined).length === 0) {
          this.validationErrors.push(
            this.$t(
              `components.plan_builder.employers_import_wizard.errors.Row {0}: {1}'s Name is required`,
              [i + 2, "Parameter"]
            )
          );
          console.log("Name is missing");
        } else {
          if (!this.isUniqueParameterName(i, parameters)) {
            this.validationErrors.push(
              this.$t(
                `components.plan_builder.employers_import_wizard.errors.Row {0}: {1}'s Name must be unique`,
                [i + 2, "Parameter"]
              )
            );
          }
        }
        if (parameters[i].ConfigurationParameter.ParameterType === null || parameters[i].ConfigurationParameter.ParameterType === undefined) {
          this.validationErrors.push(
            this.$t(
              `components.plan_builder.coverage_parameters_import_wizard.errors.Row {0}: {1}'s Parameter Type is required`,
              [i + 2, "Parameter"]
            )
          );
        } else {
          if (!this.isCorrectParameterType(parameters[i].ConfigurationParameter.ParameterType)) {
            this.validationErrors.push(
              this.$t(
                `components.plan_builder.coverage_parameters_import_wizard.errors.Row {0}: {1}'s Parameter Type must be corect type`,
                [i + 2, "Parameter"]
              )
            );
          }
        }
        if (parameters[i].ConfigurationParameter.UsedInFormulaType === null || parameters[i].ConfigurationParameter.UsedInFormulaType === undefined) {
          this.validationErrors.push(
            this.$t(
              `components.plan_builder.coverage_parameters_import_wizard.errors.Row {0}: {1}'s Participates in Formula value is required`,
              [i + 2, "Parameter"]
            )
          );
        } else {
          if (!this.isCorrectFormulaType(i, parameters)) {
            this.validationErrors.push(
              this.$t(
                `components.plan_builder.coverage_parameters_import_wizard.errors.Row {0}: {1}'s Participates in Formula value must be correct and one of the following: {2}`,
                [
                  i + 2,
                  "Parameter",
                  this.formulaTypes.join(", "),
                ]
              )
            );
          }
        }
        if (parameters[i].ConfigurationParameter.UsedInFormulaType === "AdminFee" && (parameters[i].ConfigurationParameter.Coverage === null || parameters[i].ConfigurationParameter.Coverage === undefined)) {
          this.validationErrors.push(
            this.$t(
              `components.plan_builder.coverage_parameters_import_wizard.errors.Row {0}: {1}'s Coverage is required`,
              [i + 2, "Parameter"]
            )
          );
        }
        if (parameters[i].ConfigurationParameter.UsedInFormulaType === "EmployerContribution" && (parameters[i].ContributionCategory === null || parameters[i].ContributionCategory === undefined)) {
          this.validationErrors.push(
            this.$t(
              `components.plan_builder.coverage_parameters_import_wizard.errors.Row {0}: {1}'s Contribution Category is required`,
              [i + 2, "Parameter"]
            )
          );
        }
        if (parameters[i].ConfigurationParameter.UsedInFormulaType === "PensionAccruedBenefit" && (parameters[i].ConfigurationParameter.Identity.Employer === null || parameters[i].ConfigurationParameter.Identity.Employer === undefined)) {
          this.validationErrors.push(
            this.$t(
              `components.plan_builder.coverage_parameters_import_wizard.errors.Row {0}: {1}'s Employer is required`,
              [i + 2, "Parameter"]
            )
          );
        }
        if (parameters[i].ConfigurationParameterValue.Value === null || parameters[i].ConfigurationParameterValue.Value === undefined) {
          this.validationErrors.push(
            this.$t(
              `components.plan_builder.coverage_parameters_import_wizard.errors.Row {0}: {1}'s Value is required`,
              [i + 2, "Parameter"]
            )
          );
        } else {
          if (parameters[i].ConfigurationParameter.ParameterType === "Amount" || parameters[i].ConfigurationParameter.ParameterType === "Percentage" || parameters[i].ConfigurationParameter.ParameterType === "Rate") {
            if (!this.isNumericDecimal(parameters[i].ConfigurationParameterValue.Value)) {
              this.validationErrors.push(
                this.$t(
                  `components.plan_builder.coverage_parameters_import_wizard.errors.Row {0}: {1}'s Value must be numeric`,
                  [i + 2, "Parameter"]
                )
              );
            }
          }
        }
      }

      if (this.validationErrors.length === 0) {
        this.parameters = parameters.map((o) => {
          delete o.undefined;
          return o;
        });
      }
    },
    isNumeric(v) {
      return /^[0-9]*$/.test(v);
    },
    isNumericDecimal(v) {
      // include decimals and negative numbers
      return /^-?[0-9]\d*(\.\d+)?$/.test(v);
    },
    isUniqueParameterName(index, parameters) {
      // console.log("index, parameters", index, parameters);
      for (let i = 0; i < parameters.length; i++) {
        if (index !== i) {
          if (parameters[i].ConfigurationParameter.Translations[0].Name === parameters[index].ConfigurationParameter.Translations[0].Name) {
            return false;
          }
        }
      }
      return true;
    },
    isCorrectParameterType(v) {
      return (
        v === "Constant" ||
        v === "Amount" ||
        v === "Percentage" ||
        v === "Rate"
      );
    },
    isCorrectFormulaType(index, parameters) {
      console
      const usedInFormulaTypeValue = parameters[index].ConfigurationParameter.UsedInFormulaType.replaceAll(" ", "");
      if (this.formulaTypes.filter((o) => o === usedInFormulaTypeValue).length === 0) {
        return false;
      }
      return true;
    },
    finish() {
      this.$emit("parameters", this.parameters);
      console.log("emit imported parameters", this.parameters);
    },
    cancel() {
      this.dialog = false;
      this.$emit("close");
    },
    onUploadStarted() {
      this.uploaded = false;
      this.uploading = true;
    },
    onUploadCompleted(res) {
      this.uploaded = true;
      this.uploading = false;
      this.uploadResult = this.$t("globals.upload_successful");
    },
    onUploadError(err) {
      //console.log("ERR");
      //console.log(JSON.stringify(err));
      this.uploaded = true;
      this.uploading = false;
      this.error = err;
    },

    async downloadTemplate(filled) {
      return;
      this.downloading = true;
      const url =
        "plans/" +
        this.selectedPlan.Id +
        "/member-import" +
        (filled
          ? "/with-data/" + this.planRenewalDate
          : "/" + this.planRenewalDate);

      const filename = "Template.xlsx";
      try {
        let blob = (await this.getBlobAsync({ url: url, filename: filename }))
          .data;

        const url2 = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url2;
        link.setAttribute("download", filename); //or any other extension
        link.setAttribute("id", "link1"); //or any other extension
        document.body.appendChild(link);
        link.click();
        var element = document.getElementById("link1");
        element.parentNode.removeChild(element);
      } catch (error) {
        this.error = error;
      }
      this.downloading = false;
    },
  },
};
</script>
